<template>
  <model @clickHandler="exit" class="tick-model">
    <img src="@img/success.png" class="success" @click="exit" />
    <span class="num">{{ num }}</span>
  </model>
</template>

<script>
export default {
  name: 'tick-success',
  data() {
    return {
      once: true,
    };
  },
  computed: {
    num() {
      return this.$route.params.num;
    },
  },
  methods: {
    exit() {
      if (!this.once) return;
      this.once = false;
      this.$router.go(-1);
      this.$parent.callLottery();
    },
  },
};
</script>

<style lang="scss" scoped>
.success {
  position: absolute;
  @include center(453);
  @include w(453);
  top: 4.5rem;
  z-index: 11;
}
.num {
  position: absolute;
  font-size: 0.6rem;
  color: #fff43e;
  top: 8.76rem;
  left: 8.2rem;
  z-index: 12;
  font-weight: 600;
}
</style>
